import { useLocation, useNavigate, useParams as useRouterParams, useSearchParams as useRouterSearchParams } from 'react-router-dom'

export function usePathname() {
  return useLocation().pathname
}

export function useParams() {
  return useRouterParams()
}

export function useSearchParams() {
  const [searchParams] = useRouterSearchParams()
  return searchParams
}

export function useRouter() {
  const navigate = useNavigate()

  return {
    push: (href: string) => navigate(href),
    replace: (href: string) => navigate(href, { replace: true }),
    back: () => navigate(-1),
    refresh: () => window.location.reload(),
  }
}

export function redirect(href: string): never {
  window.location.assign(href)
  throw new Error(`Redirected to ${href}`)
}

export function notFound(): never {
  throw new Error('Not found')
}
